export const AUTORESPONDER_STUDENT_PLACEHOLDER_FIELDS = [
    {
        id: 'studentHouse',
        label: 'Student House',
    },
    {
        id: 'studentForm',
        label: 'Student Form',
    },
    {
        id: 'studentYearGroup',
        label: 'Student Year Group',
    },
    {
        id: 'studentIntakeGroup',
        label: 'Student Intake Group',
    },
    {
        id: 'studentBoarderStatus',
        label: 'Student Boarder Status',
    },
];

export const isAutoresponderStudentPlaceholderField = (fieldId) =>
    AUTORESPONDER_STUDENT_PLACEHOLDER_FIELDS.some((field) => field.id === fieldId);
